angular
    .module('app')
    .component('leads', {
        templateUrl: '/templates/pages/leads/leads.html',
        controller: 'LeadsController',
        controllerAs: 'vm',
    });